<div class="px-2 py-3">
  <div class="d-flex mb-3">
    <div [ngClass]="selectMode ? 'col-4' : 'col-3'">
      <div class="font-weight-bold">
        Nombre
      </div>
      <input type="text" class="form-control" [(ngModel)]="nameFilter" (input)="applyFilters()">
    </div>
    <div [ngClass]="selectMode ? 'col-4' : 'col-3'">
      <div class="font-weight-bold">
        Materia
      </div>
      <select class="form-control" [(ngModel)]="selectedSubject" (ngModelChange)="getSubjectChildren($event)">
        <option [ngValue]="undefined">Todas</option>
        @for (subject of subjects; track subject) {
          <option [ngValue]="subject">{{subject.name}}</option>
        }
      </select>
    </div>
    <div [ngClass]="selectMode ? 'col-4' : 'col-3'">
      <div class="font-weight-bold">
        Submateria
      </div>
      <select class="form-control" [(ngModel)]="selectedSubjectChild" (ngModelChange)="applyFilters()">
        <option [ngValue]="undefined">Todas</option>
        @for (child of subjectChilds; track child) {
          <option [ngValue]="child">{{child.name}}</option>
        }
      </select>
    </div>
    @if (!selectMode) {
      <div class="col-3 d-flex justify-content-center align-items-center">
        <button class="btn btn-secondary" (click)="openClauseCreator()">Nuevo</button>
      </div>
    }
  </div>
  <div class="d-flex">
    @if (selectMode) {
      <div class="col-1"></div>
    }
    <div class="text-center font-weight-bold" [ngClass]="selectMode ? 'col-4' : 'col-3'">
      Nombre
    </div>
    <div class="text-center font-weight-bold" [ngClass]="selectMode ? 'col-7' : 'col-6'">
      Contenido
    </div>
    @if (!selectMode) {
      <div class="col-3 text-center font-weight-bold">
        Acciones
      </div>
    }
  </div>
  @for (section of filteredClauses; track section) {
    <div class="d-flex border-bottom py-3">
      @if (selectMode) {
        <div class="col-1 d-flex align-items-center">
          <input type="checkbox" [(ngModel)]="selectedClauses[section.id]" (change)="emitSelectionChange()">
        </div>
      }
      <div class="text-col d-flex align-items-center" [ngClass]="selectMode ? 'col-4' : 'col-3'">
        {{section.name}}
      </div>
      <div class="text-col" [ngClass]="selectMode ? 'col-7' : 'col-6'" [innerHTML]="section.content">
      </div>
      @if (!selectMode) {
        <div class="col-3 d-flex align-items-center justify-content-center">
          <i class="far fa-edit mx-2 cursor-pointer" (click)="editSection(section)"></i>
          <i class="far fa-trash-alt mx-2 cursor-pointer" (click)="deleteSection(section.id)"></i>
        </div>
      }
    </div>
  }
</div>